export default __webpack_public_path__ + "static/media/3.a9d30969.png";